<template>
    <v-dialog
        v-if="!$vuetify.display.mobile"
        v-model="internal_value"
        :persistent="persistent"
        @after-leave="() => $emit('after-leave')"
        width="600"
    >
        <v-row
            justify="center"
            no-gutters
        >
            <v-sheet
                class="rounded-xl overflow-hidden"
                width="600"
            >
                <div v-if="show_header">
                    <v-toolbar color="transparent">
                        <v-toolbar-title :class="{ 'font-weight-bold': bold_title }">{{ title || '' }}</v-toolbar-title>
                        <v-btn
                            @click="internal_value = false"
                            icon
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-divider
                        v-if="header_divider"
                        class="mb-4"
                    />
                </div>

                <slot name="content" />
            </v-sheet>
        </v-row>
    </v-dialog>

    <v-bottom-sheet
        v-if="$vuetify.display.mobile"
        v-model="internal_value"
        :persistent="persistent"
        @after-leave="() => $emit('after-leave')"
        inset
    >
        <v-row
            justify="center"
            no-gutters
        >
            <v-sheet
                class="rounded-t-xl"
                width="600"
            >
                <div v-if="show_header">
                    <v-toolbar color="transparent">
                        <v-toolbar-title :class="{ 'font-weight-bold': bold_title }">{{ title || '' }}</v-toolbar-title>
                        <v-btn
                            @click="internal_value = false"
                            icon
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-divider
                        v-if="header_divider"
                        class="mb-4"
                    />
                </div>

                <slot name="content" />
            </v-sheet>
        </v-row>
    </v-bottom-sheet>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'ActionDialog',
    props: {
        modelValue: {
            type: Boolean,
        },
        title: String,
        header_divider: {
            type: Boolean,
            default: true,
        },
        bold_title: {
            type: Boolean,
            default: false,
        },
        show_header: {
            type: Boolean,
            default: true,
        },
        persistent: {
            type: Boolean,
            default: false,
        },
    },
    mixins: [],
    components: {},
    data() {
        return {}
    },
    computed: {
        internal_value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            },
        },
        ...mapState([]),
    },
    watch: {},
    methods: {
        ...mapActions([]),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
    unmounted() {},
}
</script>

<style scoped></style>
